<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5
        class="modal-title"
        id="TruckModalLabel"
      >Add</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <form
        class="form-horizontal needs-validation"
        novalidate
        id="formAddTruck"
      >
        <!-- Row -->
        <div class="row">
          <!-- Column -->
          <div class="col-lg-6 col-xlg-6 col-md-6">
            <div class="mb-3">
              <label class="col-md-12">Supplier</label>
              <div class="col-md-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="spl_name"
                  readonly
                />
                <input
                  type="hidden"
                  class="form-control"
                  v-model="spl_id"
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Pattern</label>
              <div class="col-md-12">
                <select
                  v-model="cdp_id"
                  class="form-control-line form-select form-select-fix"
                  style="width: 100%"
                  required
                  placeholder="Choose pattern..."
                >
                  <option
                    selected
                    value=""
                  >Choose pattern</option>
                  <option
                    v-for="(cdp, i) in patternModalList"
                    :key="'cdp' + i"
                    :value="cdp.cdp_id"
                  >
                    {{ cdp.cdp_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Truck No.</label>
              <div class="col-md-12">
                <input
                  type="number"
                  v-model="cdpl_truck_no"
                  class="form-control"
                  required
                />
                <div class="invalid-feedback">
                  Please enter truck No.
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Lead-Time Day (S)</label>
              <div class="col-md-12">
                <input
                  type="number"
                  v-model="cdpl_lead_time_day"
                  class="form-control"
                  required
                />
                <div class="invalid-feedback">
                  Please enter lead-time day (S).
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Day</label>
              <a-row>
                <a-col :span="8">
                  <a-checkbox
                    v-model="cdmp_mon"
                    value="1"
                  >
                    Mon
                  </a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox
                    v-model="cdmp_tue"
                    value="1"
                  >
                    Tue
                  </a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox
                    v-model="cdmp_wed"
                    value="1"
                  >
                    Wed
                  </a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox
                    v-model="cdmp_thu"
                    value="1"
                  >
                    Thu
                  </a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox
                    v-model="cdmp_fri"
                    value="1"
                  >
                    Fri
                  </a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox
                    v-model="cdmp_sat"
                    value="1"
                  >
                    Sat
                  </a-checkbox>
                </a-col>
              </a-row>
            </div>
          </div>
          <!-- Column -->
          <!-- Column -->
          <div class="col-lg-6 col-xlg-6 col-md-6">
            <div class="mb-3">
              <label class="col-md-12">Plant Code</label>
              <div class="col-md-12">
                <input
                  type="text"
                  v-model="spl_plant_code"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Truck type</label>
              <div class="col-md-12">
                <!-- <input
                  type="text"
                  class="form-control"
                  v-model="cdpl_truck_type"
                  required
                />
                <div class="invalid-feedback">
                  Please enter sequence.
                </div> -->
                <select
                  v-model="cdpl_truck_type"
                  class="form-control-line form-select form-select-fix"
                  style="width: 100%"
                  placeholder="Choose Truck Type..."
                >
                  <option
                    selected
                    value=""
                  >Choose truck type</option>
                  <option
                    v-for="(tt, i) in trucktypeModalList"
                    :key="'tt' + i"
                    :value="tt.tt_name"
                  >
                    {{ tt.tt_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Shipping time</label>
              <div class="row">
                <div class="col-md-6">
                  <select
                    v-model="cdpl_shipping_time_h"
                    class="form-control-line form-select form-select-fix"
                    style="width: 100%"
                    required
                    placeholder="Choose Shipping Time..."
                  >
                    <option value="00">00</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <select
                    v-model="cdpl_shipping_time_m"
                    class="form-control-line form-select form-select-fix"
                    style="width: 100%"
                    required
                    placeholder="Choose Shipping Minute..."
                  >
                    <option value="00">00</option>
                    <option value="05">05</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="35">35</option>
                    <option value="40">40</option>
                    <option value="45">45</option>
                    <option value="50">50</option>
                    <option value="55">55</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Delivery start time</label>
              <div class="row">
                <div class="col-md-6">
                  <select
                    v-model="cdpl_delivery_time_h"
                    class="form-control-line form-select form-select-fix"
                    style="width: 100%"
                    required
                    placeholder="Choose Delivery Start Time..."
                  >
                    <option value="00">00</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <select
                    v-model="cdpl_delivery_time_m"
                    class="form-control-line form-select form-select-fix"
                    style="width: 100%"
                    required
                    placeholder="Choose Delivery Start Minute..."
                  >
                    <option value="00">00</option>
                    <option value="05">05</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="35">35</option>
                    <option value="40">40</option>
                    <option value="45">45</option>
                    <option value="50">50</option>
                    <option value="55">55</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Delivery finish time</label>
              <div class="row">
                <div class="col-md-6">
                  <select
                    v-model="cdpl_delivery_time_end_h"
                    class="form-control-line form-select form-select-fix"
                    style="width: 100%"
                    required
                    placeholder="Choose Delivery Finish Time..."
                  >
                    <option value="00">00</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <select
                    v-model="cdpl_delivery_time_end_m"
                    class="form-control-line form-select form-select-fix"
                    style="width: 100%"
                    required
                    placeholder="Choose Delivery Finish Minute..."
                  >
                    <option value="00">00</option>
                    <option value="05">05</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="35">35</option>
                    <option value="40">40</option>
                    <option value="45">45</option>
                    <option value="50">50</option>
                    <option value="55">55</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
        <!-- Row -->
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary btn-fix"
        data-bs-dismiss="modal"
        id="supplierModalclose"
      ><i class="fa fa-times"></i> Close</button>
      <button
        type="button"
        class="btn btn-info btn-fix"
        @click="checkForm"
        id="submitbtn"
      ><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>

<script>
import api from '../../models/truck'
// import moment from 'moment'

export default {
  props: ['modalAddTruck', 'loadNewTruck'],
  data () {
    return {
      cdp_id: '',
      spl_id: '',
      // cdmp_sequence: '',
      cdpl_truck_no: '',
      cdpl_truck_type: '',
      cdpl_shipping_time: '',
      cdpl_shipping_time_h: '00',
      cdpl_shipping_time_m: '00',
      cdpl_lead_time_day: '',
      cdpl_delivery_time: '',
      cdpl_delivery_time_h: '00',
      cdpl_delivery_time_m: '00',
      cdpl_delivery_end_time: '',
      cdpl_delivery_time_end_h: '00',
      cdpl_delivery_time_end_m: '00',
      cdmp_mon: false,
      cdmp_tue: false,
      cdmp_wed: false,
      cdmp_thu: false,
      cdmp_fri: false,
      cdmp_sat: false,
      spl_name: '',
      spl_plant_code: '',
      patternModalList: [],
      trucktypeModalList: []
    }
  },
  methods: {
    // moment,
    checkForm () {
      if (this.cdp_id !== '' && this.spl_id !== '' && this.cdpl_truck_no !== '' && this.cdpl_shipping_time_h !== '' && this.cdpl_shipping_time_m !== '' && this.cdpl_lead_time_day !== '' && this.cdpl_delivery_time_h !== '' && this.cdpl_delivery_time_m !== '' && this.cdpl_delivery_time_end_h !== '' && this.cdpl_delivery_time_end_m !== '') {
        this.insertTruck()
      } else {
        $('#formAddTruck').addClass('was-validated')
      }
    },
    insertTruck () {
      $('.preloader').fadeIn()
      let formData = {
        cdp_id: this.cdp_id,
        spl_id: this.spl_id,
        // cdmp_sequence: this.cdmp_sequence,
        cdpl_truck_no: this.cdpl_truck_no,
        cdpl_truck_type: this.cdpl_truck_type,
        // cdpl_shipping_time: this.dateFormatTime(this.cdpl_shipping_time),
        cdpl_shipping_time_h: this.cdpl_shipping_time_h,
        cdpl_shipping_time_m: this.cdpl_shipping_time_m,
        cdpl_lead_time_day: this.cdpl_lead_time_day,
        cdpl_delivery_time_h: this.cdpl_delivery_time_h,
        cdpl_delivery_time_m: this.cdpl_delivery_time_m,
        cdpl_delivery_time_end_h: this.cdpl_delivery_time_end_h,
        cdpl_delivery_time_end_m: this.cdpl_delivery_time_end_m,
        cdmp_mon: this.cdmp_mon,
        cdmp_tue: this.cdmp_tue,
        cdmp_wed: this.cdmp_wed,
        cdmp_thu: this.cdmp_thu,
        cdmp_fri: this.cdmp_fri,
        cdmp_sat: this.cdmp_sat

      }
      api.addTruck(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.loadNewTruck()
            this.alert_msg('success', 'Successful', result.message)
            $('.preloader').fadeOut()
            $('#TruckModal').modal('hide')
          } else {
            this.loadNewTruck()
            this.alert_msg('warning', 'An error occurred.', result.message)
            $('.preloader').fadeOut()
            $('#TruckModal').modal('hide')
          }
        },
        error => {
          this.loadNewTruck()
          this.alert_msg('error', 'An error occurred.', error.message)
          $('.preloader').fadeOut()
          $('#TruckModal').modal('hide')
        }
      )
    },
    listPattern () {
      this.patternModalList = []
      api.listPattern(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.patternModalList = result.data
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    listTrucktype () {
      this.trucktypeModalList = []
      api.listTrucktype(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.trucktypeModalList = result.data
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    }
  },
  watch: {
    modalAddTruck: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.listPattern()
        this.listTrucktype()
        this.spl_name = newValue.spl_name
        this.spl_id = newValue.spl_id
        this.spl_plant_code = newValue.spl_plant_code
        // this.cdmp_sequence = newValue.cdmp_sequence
      }
    }
  },
  mounted () {
    var myModalEl = document.getElementById('TruckModal')
    myModalEl.addEventListener('shown.bs.modal', event => {
      this.cdp_id = '1'
      this.cdpl_truck_no = ''
      this.cdpl_truck_type = ''
      this.cdpl_shipping_time_h = '00'
      this.cdpl_shipping_time_m = '00'
      this.cdpl_lead_time_day = ''
      this.cdpl_delivery_time_h = '00'
      this.cdpl_delivery_time_m = '00'
      this.cdpl_delivery_time_end_h = '00'
      this.cdpl_delivery_time_end_m = '00'
      this.cdmp_mon = false
      this.cdmp_tue = false
      this.cdmp_wed = false
      this.cdmp_thu = false
      this.cdmp_fri = false
      this.cdmp_sat = false
      $('#formAddTruck').removeClass('was-validated')
    })
    $(document).on('show.bs.modal', '.modal', function () {
      var zIndex = 1040 + (10 * $('.modal:visible').length)
      $(this).css('z-index', zIndex)
      setTimeout(function () {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack')
      }, 0)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/truck_add_modal.vue